import { Icon, IconProps } from '@chakra-ui/react'

export default function MyGroupsIcon(props: IconProps & { stroke?: string }) {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <circle
        cx="8.99829"
        cy="9.50854"
        r="3.49145"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="18.0021"
        cy="10.4991"
        r="2.50104"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.99585 21.0035V19.9861C2.99585 17.7852 4.77959 16.0015 6.98051 16.0015H11.0162C13.2171 16.0015 15.0008 17.7852 15.0008 19.9861V21.0035"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0021 16.0015H19.1045C21.3055 16.0015 23.0892 17.7852 23.0892 19.9861V21.0035"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
